import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { contactInfo, coverageAreas } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">Mobil Yol Yardım</span>
            </div>
            <p className="text-sm mb-4">
              İstanbul Kadıköy bölgesinde 7/24 profesyonel mobil yol yardım hizmeti.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-orange-500 transition-colors">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm hover:text-orange-500 transition-colors">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-sm hover:text-orange-500 transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-sm hover:text-orange-500 transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-orange-500" />
                <span className="text-sm">{contactInfo.phone}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-orange-500" />
                <span className="text-sm">{contactInfo.email}</span>
              </li>
              <li className="flex items-center space-x-3">
                <MapPin className="w-4 h-4 text-orange-500" />
                <span className="text-sm">{contactInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Clock className="w-4 h-4 text-orange-500" />
                <span className="text-sm">{contactInfo.workingHours}</span>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hizmet Bölgeleri</h3>
            <p className="text-sm mb-2">Kadıköy ve tüm ilçeleri:</p>
            <div className="flex flex-wrap gap-2">
              {coverageAreas.slice(0, 8).map((area, index) => (
                <span key={index} className="text-xs bg-gray-800 px-2 py-1 rounded">
                  {area}
                </span>
              ))}
              <span className="text-xs text-orange-500">+{coverageAreas.length - 8} daha</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Mobil Yol Yardım. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;